const ivrcsvcolumndata = [
  { id: "ivr_menu_name", title: "Name", default: true },
  { id: "ivr_menu_extension", title: "Extension", default: true },
  { id: "ivr_menu_description", title: "Description" },
  { id: "ivr_menu_timeout", title: "Timeout" },
  { id: "ivr_menu_enabled", title: "Status", default: true },
];
export default ivrcsvcolumndata;
